/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';
import type { CreateTimeEntryRequestAppointmentId } from './CreateTimeEntryRequestAppointmentId';
import {
    CreateTimeEntryRequestAppointmentIdFromJSON,
    CreateTimeEntryRequestAppointmentIdFromJSONTyped,
    CreateTimeEntryRequestAppointmentIdToJSON,
    CreateTimeEntryRequestAppointmentIdToJSONTyped,
} from './CreateTimeEntryRequestAppointmentId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface LogAttendanceRequest
 */
export interface LogAttendanceRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LogAttendanceRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof LogAttendanceRequest
     */
    date: Date;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof LogAttendanceRequest
     */
    status: AttendanceStatus;
    /**
     * 
     * @type {string}
     * @memberof LogAttendanceRequest
     */
    timeIn: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogAttendanceRequest
     */
    timeOut: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof LogAttendanceRequest
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof LogAttendanceRequest
     */
    appointmentId: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {string}
     * @memberof LogAttendanceRequest
     */
    remarks: string | null;
}



/**
 * Check if a given object implements the LogAttendanceRequest interface.
 */
export function instanceOfLogAttendanceRequest(value: object): value is LogAttendanceRequest {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('timeIn' in value) || value['timeIn'] === undefined) return false;
    if (!('timeOut' in value) || value['timeOut'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function LogAttendanceRequestFromJSON(json: any): LogAttendanceRequest {
    return LogAttendanceRequestFromJSONTyped(json, false);
}

export function LogAttendanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogAttendanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'date': (new Date(json['date'])),
        'status': AttendanceStatusFromJSON(json['status']),
        'timeIn': json['timeIn'],
        'timeOut': json['timeOut'],
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'appointmentId': CreateTimeEntryRequestAppointmentIdFromJSON(json['appointmentId']),
        'remarks': json['remarks'],
    };
}

export function LogAttendanceRequestToJSON(json: any): LogAttendanceRequest {
    return LogAttendanceRequestToJSONTyped(json, false);
}

export function LogAttendanceRequestToJSONTyped(value?: LogAttendanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'date': value['date'].toISOString().substring(0,10),
        'status': AttendanceStatusToJSON(value['status']),
        'timeIn': value['timeIn'],
        'timeOut': value['timeOut'],
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'appointmentId': CreateTimeEntryRequestAppointmentIdToJSON(value['appointmentId']),
        'remarks': value['remarks'],
    };
}

